import { InfoCircleOutlined } from "@ant-design/icons";

export const AlertEmpty = ({ text }) => {
  return (
    <div
      style={{
        border: "1px solid #d9d9d9",
        backgroundColor: "rgba(0,0,0,0.01)",
        borderRadius: "4px",
        padding: "6px 10px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        position: "relative",
      }}
    >
      <InfoCircleOutlined
        style={{
          color: "#444",
          fontSize: "16px",
          position: "relative",
          top: "1px",
        }}
      />
      <span>{text}</span>
    </div>
  );
};
